import React, { useState, useEffect, Fragment } from 'react';
import { Row, Button } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { RotateSpinner } from 'react-spinners-kit';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DialogResponse from './ResponseBlock/DialogResponse';
import Dialog from './Dialog/Dialog';
import {
  gAPI_BotDialogFile,
  postAPI_UploadBotDialogFile,
  postAPI_BotDialogFile,
} from '../../../../../constants/APIs';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import classnames from 'classnames';

function ResponseBlock({ filename, propertyId, locale }) {
  console.log('filename', filename);
  const [responseData, setResponseData] = useState(null);
  const [result, setResult] = useState(null);
  const [dialogNames, setDialogNames] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAddNew, setAddNew] = useState(false);
  const [ApiState, setApiState] = useState('default');
  const dialogUpdate = (dialog, index) => {
    const newData = [...responseData];
    newData[index] = dialog;
    console.log(newData);
    setResponseData(newData);
    AxiosAPI({
      method: 'POST',
      url: `${postAPI_BotDialogFile}`,
      data: { fileName: filename, content: newData },
    })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    setApiState('default');
  };
  const dialogDelete = (index) => {
    const newData = [...responseData];
    newData.splice(index, 1);
    console.log(newData);
    setResponseData(newData);
    AxiosAPI({
      method: 'POST',
      url: `${postAPI_BotDialogFile}`,
      data: { fileName: filename, content: newData },
    })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    setApiState('default');
  };
  const toggleNew = () => {
    setAddNew(!isAddNew);
  };
  const dialogNew = (dialog) => {
    const newData = [...responseData];
    newData.push(dialog);
    console.log(newData);
    setResponseData(newData);
    const names = newData.map((m) => m.name);
    setDialogNames(names);
    AxiosAPI({
      method: 'POST',
      url: `${postAPI_BotDialogFile}`,
      data: { fileName: filename, content: newData },
    })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handlePublish = () => {
    setApiState('processing');
    AxiosAPI({
      method: 'POST',
      url: `${postAPI_UploadBotDialogFile}`,
      data: { fileName: filename },
    })
      .then((res) => {
        console.log(res.data);
        setApiState('success');
        NotificationManager.success(
          '',
          'File publish successfully',
          3000,
          null,
          null,
          'success'
        );
      })
      .catch((err) => {
        setApiState('fail');
        console.log(err);
      });
    setApiState('default');
  };

  const reloadBotResponse = async () => {
    setIsLoading(true);
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_BotDialogFile}/?name=${filename}`,
    })
      .then((res) => {
        setResponseData(res.data);
        const names = res.data.map((m) => m.name);
        setDialogNames(names);
        console.log(res.data);
        setIsLoading(false);
        //console.log('All Bot Response', res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    reloadBotResponse();
  }, [filename]);

  const generator = () => {
    console.log('responsedata', responseData);
    if (responseData) {
      return responseData.map((elem, index) => {
        return (
          <Fragment>
            <DialogResponse
              elem={elem}
              key={index}
              dialogIndex={index}
              dialogUpdate={dialogUpdate}
              dialogDelete={dialogDelete}
              dialogNames={dialogNames}
            />
          </Fragment>
        );
      });
    } else return null;
  };

  return (
    <Fragment>
      {isLoading ? (
        <Row>
          <Colxx xxs="5" className="mb-2"></Colxx>
          <Colxx xxs="2" className="mb-2">
            <RotateSpinner size={60} color="#4556AC" loading={isLoading} />
          </Colxx>
          <Colxx xxs="5" className="mb-2"></Colxx>
        </Row>
      ) : (
        <Fragment>
          <Row className="mb-2">
            <Colxx xxs="3"></Colxx>
            <Colxx xxs="">
              <div className="float-left">
                <Button color="primary" className="default" onClick={toggleNew}>
                  Add New Dialog
                </Button>
              </div>
            </Colxx>
            <Colxx xxs="6">
              <div className="float-right">
                <Button
                  color="primary"
                  //className="default"
                  onClick={handlePublish}
                  className={`default btn-multiple-state ${classnames({
                    'show-spinner': ApiState === 'processing',
                    'show-success': ApiState === 'success',
                    'show-fail': ApiState === 'fail',
                  })}`}
                >
                  <span className="spinner d-inline-block">
                    <span className="bounce1" />
                    <span className="bounce2" />
                    <span className="bounce3" />
                  </span>
                  <span className="icon success">
                    <i className="simple-icon-check" />
                  </span>
                  <span className="icon fail">
                    <i className="simple-icon-exclamation" />
                  </span>
                  <span className="label">Publish</span>
                </Button>
              </div>
            </Colxx>
          </Row>
          {isAddNew && (
            <Row className="mb-2">
              <Colxx xxs="3"></Colxx>
              <Colxx xxs="9">
                <Dialog
                  setIsAddMsgToFalse={() => setAddNew(false)}
                  dialogNew={dialogNew}
                />
              </Colxx>
            </Row>
          )}
          {generator()}
        </Fragment>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps)(ResponseBlock));
